export const PAGE_TYPE = Object.freeze({
  HOME_PAGE: "home-page",
  SECTION_PAGE: "section-page",
  SUB_SECTION_PAGE: "sub-section-page",
  COLLECTION_PAGE: "collection-page",
  TAG_PAGE: "tag-page",
  CARTOON_PAGE: "cartoon-page",
  SEARCH_PAGE: "search-page",
  STORY_PAGE: "story-page",
  AUTHORS_PAGE: "authors-page",
  AUTHOR_PAGE: "author-page",
  STORY_PUBLIC_PREVIEW_PAGE: "story-public-preview-page",
  CATALOG_PAGE: "catalog-page",
  STORY_PREVIEW: "story-preview",
  HOME_PREVIEW: "home-preview",
  STATIC_PAGE: "static-page",
  RESET_PASSWORD_PAGE: "reset-password-page",
  PROFILE_PAGE: "profile-page",
  USER_LOGIN: "user-login",
  VISUAL_STORY: "visual-story",
  HOROSCOPE_PAGE: "horoscope-page",
  INSTAGRAM_PAGE: "instagram-page",
  NEWS_SHOTS_PAGE: "news-shots-page",
  NEWSLETTERS_PAGE: "newsletters",
  NEWSLETTERS_UNSUBSCRIBE_PAGE: "news-letters-unsubscribe",
  SUBSCRIPTION_PAGE: "subscription-page",
  BRAND_SPOT_PAGE: "brandspot-page",
  STUDENTS_CONTEST: "students-contest",
  PUZZLE_CONTEST: "puzzle-contest",
  PREMIUM_PAGE: "premium-page",
  SUBSCRIBE_PAGE: "subscribe-page",
});
export const TAG_PAGE_URL_PREFIX = "/tags/";
export const storyFields =
  "headline,id,subheadline,slug,seo,url,hero-image-s3-key,hero-image-caption,hero-image-metadata,first-published-at,last-published-at,alternative,published-at,authors,author-name,author-id,sections,story-template,metadata,tags,access";

export const STATIC_KEYWORDS = {
  PREFER: "Prefer",
  TRUSTED: "As Trusted",
  JOIN_US: "Join Us",
};

export const SUBSCRIPTION_PAGE_STRINGS = {
  DH: {
    WHY_CHOOSE_HEADING: "Why choose DH?",
    TESTIMONIALS_HEADING: "What Our Readers Say",
    FAQ_HEADING: "Frequently Asked Questions",
    FOOTER_CONTACT_TITLE: "Having trouble? Contact us at:",
    WORKING_HOURS_LABEL: "Working hours"
  }
};

export const SUBSCRIBE_PAGE_TEXT = {
  SUCCESS_TITLE: "Payment Successful!",
  SUCCESS_SUBTITLE: "Welcome! Your subscription is now active.",
  REDIRECT_PREFIX: "You will be redirected to ",
  REDIRECT_IN: " in ",
  REDIRECT_SUFFIX: " seconds...",

  // Upgrade & Downgrade Modals
  UPGRADE_POPUP_BTN: "OK",
  DOWNGRADE_POPUP_BTN: "OK",

  // Review Page
  REVIEW_TITLE: "Review & Pay",
  EDIT: "Edit",
  START_DATE: "Start Date: ",
  END_DATE: "End Date: ",
  AMOUNT_LABEL: "Amount ",
  AMOUNT_TAX: "(Inclusive Of Taxes)",
  RENEWAL_TEXT: "Your Subscription Renews Automatically, Cancel Anytime.",
  PROCEED_TO_PAY: "Proceed To Pay",
  LOGIN_PREFIX: "Logged in as ",
  CHANGE_ACCOUNT: "Change Account",

  FAILURE_TITLE: "Payment Failed!",
  FAILURE_MSG: "Your payment was unsuccessful. Please try again or use a different mode of payment..",
  RETRY_CTA: "Retry Payment",
  REVIEW_CTA: "Go Back & Review",
  RETURN_LINK: "Go to Deccan Herald",
  CONTACT_PREFIX: "Facing Issues? ",
  CONTACT_SUFFIX: "Contact us",
  TIMING_TITLE: "Working hours",
  TIMING_TEXT: "Mon - Fri : 10:00 AM to 6:00 PM",
  WHATSAPP_LINK: "https://api.whatsapp.com/send/?phone=919035267305&text=Hi%2C%20I%20need%20assistance%20with%20my%20Deccan%20Herald%20Premium%20Subscription.%20Could%20you%20please%20help%20me%3F&type=phone_number&app_absent=0",
  WHATSAPP_NUMBER: "+91 9035267305",
  EMAIL_LINK: "https://mail.google.com/mail/u/0/?fs=1&to=support@deccanherald.com&su=Support%20Required%20for%20DH%20subscription&body=Hi%2C%20I%20need%20assistance%20with%20my%20Deccan%20Herald%20Premium%20Subscription.%20Could%20you%20please%20help%20me%3F&tf=cm",
  EMAIL_ID: "support@deccanherald.com",

  // Auto Cancellation Modal
  AUTO_CANCEL_TITLE: "Are you sure you want to<br/>stop auto-renewal of your subscription?",
  AUTO_CANCEL_DROPDOWN_PLACEHOLDER: "Reason For Cancellation*",
  AUTO_CANCEL_REASONS: [
    "It's a bit too expensive for me.",
    "I'm not finding the value I expected.",
    "I get my news from other sources.",
    "The website is hard to use.",
    "Others"
  ],
  AUTO_CANCEL_OTHER_PLACEHOLDER: "Enter reason here *",
  AUTO_CANCEL_ALERT_MSG: "Select a reason to continue.",
  AUTO_CANCEL_OTHER_ALERT_MSG: "Enter the reason to continue.",
  AUTO_CANCEL_INFO_TEXT: "Your subscription will remain active until the current period ends. After that, it will not automatically renew.",
  AUTO_CANCEL_BTN_KEEP: "No, Keep Active",
  AUTO_CANCEL_BTN_CANCEL: "Yes, Stop Renewal",

  // Auto Renewal Success Modal (Auto-Renewal Canceled)
  AUTORENEWAL_SUCCESS_TITLE: "Auto-Renewal Canceled",
  AUTORENEWAL_SUCCESS_DESC: "You have successfully cancelled the auto-renewal of your subscription. Your access to the current plan will continue till [Expiry Date].",
  AUTORENEWAL_SUCCESS_BTN: "OK",

  // Renewal Expired Modal
  RENEWAL_POPUP_TITLE: "Your subscription has expired!",
  RENEWAL_POPUP_SUBTITLE: "Subscribe to continue enjoying uninterrupted access to quality journalism",
  RENEWAL_POPUP_POINTS: [
    "Access to All Premium Stories",
    "Epaper Access",
    "Ad-Lite Experience"
  ],
  RENEWAL_POPUP_BTN_PRIMARY: "Renew Now",
  RENEWAL_POPUP_BTN_SECONDARY: "Remind Me Later",
};

export const FAQ_SECTION_HEADING = "Frequently Asked Questions";
export const TESTIMONIALS_SECTION_HEADING = "What Our Readers Say";
export const WHY_CHOOSE_SECTION_HEADING = "Why Choose DH Premium?";
